"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = require("styled-components");
const oxygen_config_1 = require("@8x8/oxygen-config");
const oxygen_icon_button_1 = require("@8x8/oxygen-icon-button");
const CloseLargeIcon_1 = __importDefault(require("@8x8/oxygen-icon/novo/CloseLargeIcon"));
const types_1 = require("../types");
const getColor_1 = __importDefault(require("../styled/utils/getColor"));
const structure_1 = require("../styled/structure");
const ToastWrapper_1 = __importDefault(require("../styled/ToastWrapper"));
const typeMarkings_1 = require("./typeMarkings");
const Actions_1 = __importDefault(require("./Actions"));
const Toast = ({ title, description, children, actions, hideCloseControl, onCloseControlClick, theme, ...props }) => {
    const { type } = props;
    const closeIconProps = {
        size: theme.iconSize,
        ...(theme.isClassic && { color: (0, getColor_1.default)({ theme, type }) }),
    };
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(ToastWrapper_1.default, { ...(0, oxygen_config_1.getTestAttributes)(`TOAST_${type.toUpperCase()}_CONTAINER`), ...props },
            !theme.isClassic && react_1.default.createElement(typeMarkings_1.TypeIndicator, { type: type }),
            react_1.default.createElement(structure_1.StructureWrapper, null,
                !theme.isClassic && react_1.default.createElement(typeMarkings_1.TypeIcon, { type: type, theme: theme }),
                react_1.default.createElement(structure_1.ContentWrapper, { ...(0, oxygen_config_1.getTestAttributes)('TOAST_VALUE_CONTAINER') },
                    children || (react_1.default.createElement(react_1.default.Fragment, null,
                        title && react_1.default.createElement(structure_1.Title, null, title),
                        description && react_1.default.createElement(structure_1.Description, null, description))),
                    actions?.length > 0 && react_1.default.createElement(Actions_1.default, { actions: actions, theme: theme })),
                !hideCloseControl && (react_1.default.createElement(structure_1.IconButtonWrapper, null,
                    react_1.default.createElement(oxygen_icon_button_1.IconButton, { onClick: onCloseControlClick, isInverted: theme.isClassic ? ['success', 'info'].includes(type) : true, testId: "TOAST_CLOSE_ICON" },
                        react_1.default.createElement(CloseLargeIcon_1.default, { ...closeIconProps }))))))));
};
Toast.propTypes = {
    theme: prop_types_1.default.object.isRequired,
    hideCloseControl: prop_types_1.default.bool,
    onCloseControlClick: prop_types_1.default.func,
    size: prop_types_1.default.oneOf(Object.values(types_1.toastSizes)),
    type: prop_types_1.default.oneOf(Object.values(types_1.toastTypes)),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    actions: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        title: prop_types_1.default.string.isRequired,
        id: prop_types_1.default.string,
        callback: prop_types_1.default.func.isRequired,
    })),
    children: prop_types_1.default.node,
    title: prop_types_1.default.node,
    description: prop_types_1.default.node,
};
Toast.defaultProps = {
    hideCloseControl: false,
    onCloseControlClick: undefined,
    size: types_1.toastSizes.small,
    type: types_1.toastTypes.success,
    actions: [],
    children: '',
    title: undefined,
    description: undefined,
};
exports.default = (0, oxygen_config_1.withTheme)(Toast, 'toast');
